import { SessionResponse } from '@maree/shared'

export type SessionResult =
  | { kind: 'ok'; session: SessionResponse }
  | { kind: 'beta_required' }
  | { kind: 'error'; message: string }

export async function fetchSession(fetchImpl: typeof fetch): Promise<SessionResult> {
  try {
    const res = await fetchImpl('/api/v1/session', { method: 'POST', credentials: 'same-origin' })
    if (res.status === 401) {
      const body = (await res.json().catch(() => ({}))) as { error?: string }
      if (body.error === 'beta_required') return { kind: 'beta_required' }
    }
    if (!res.ok) return { kind: 'error', message: `HTTP ${res.status}` }
    try {
      const body = await res.json()
      return { kind: 'ok', session: SessionResponse.parse(body) }
    } catch (err) {
      const message = err instanceof Error ? err.message : 'risposta non valida'
      return { kind: 'error', message }
    }
  } catch (err) {
    const message = err instanceof Error ? err.message : 'errore sconosciuto'
    return { kind: 'error', message }
  }
}

export interface SessionLoader {
  load(): Promise<SessionResult>
}

export function createSessionLoader(fetchImpl: typeof fetch): SessionLoader {
  let current: Promise<SessionResult> | null = null

  return {
    load(): Promise<SessionResult> {
      current ??= fetchSession(fetchImpl).then((result) => {
        if (result.kind !== 'ok') {
          current = null
        }
        return result
      })
      return current
    },
  }
}

const defaultLoader = createSessionLoader((input, init) => fetch(input, init))

/** Una sola richiesta per caricamento di pagina (StrictMode monta due volte in sviluppo). */
export function loadSessionOnce(): Promise<SessionResult> {
  return defaultLoader.load()
}
